// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reaction-select-list[data-v-7e5907c2]{text-align:center!important}.emoji-popover[data-v-7e5907c2]{padding:10px!important;top:calc(50% + 1.2em)!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/tabs/chat/Reaction/ChatMessageReactionSelector.vue"],"names":[],"mappings":"AACA,uCACE,2BAAA,CAGF,gCAEE,sBAAA,CADA,+BACA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
